/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { LoadingState } from "@microsoft/shifts-models-view";

import { SingleEntityState } from "./SingleEntityState";

/**
 * Creates a state for loading a single entity using generic store.
 * @returns The created state for loading a single entity using generic store.
 */
export function createSingleEntityState<TEntity>(): SingleEntityState<TEntity> {
    return {
        error: undefined,
        loadingState: LoadingState.NotStarted,
        value: undefined
    };
}
